module.exports = __webpack_public_path__ + "img/baizhan_tab_default.e51f1c18.svg";